import { useEffect } from 'react'

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    // Initialize Meta Pixel
    ;(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      // Use document.head instead of finding existing script tag
      s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        // Fallback to appending to head if no script tags exist
        b.head.appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
      undefined,
      undefined,
      undefined,
    )

    // Initialize with ID
    // @ts-ignore
    window.fbq('init', pixelId)

    // Track PageView
    // @ts-ignore
    window.fbq('track', 'PageView')
  }, [pixelId])
}
